import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

//Modules
import UserModule from "./user";
import StoryModule from "./story";
import ManagerModule from "./manager";
import Billboard from "./billboard";
import EduResource from "./edu-resource";
import DFCResource from "./dfc-resource";
import School from "./school";
import Notification from "./notification";
import MerryMamaUser from "./merrymama-user";

export default new Vuex.Store({
	modules: {
		user: UserModule,
		story: StoryModule,
		manager: ManagerModule,
		billboard: Billboard,
		EduResource: EduResource,
		DFCResource: DFCResource,
		school: School,
		notification: Notification,
		"merrymama-user": MerryMamaUser,
	},
	state: {},
	getters: {},
	mutations: {},
	actions: {
		async logout({ dispatch, commit }) {
			let $bus = new Vue().$bus;
			await dispatch("user/cleanToken");
			await commit("user/cleanUserInfo");
			await commit("story/cleanCreateStories");
			await commit("story/cleanEditStoryData");
			await commit("story/cleanStoryList");
			await commit("story/cleanPasswordStories");
			$bus.$emit("userLogout");
		},
		async managerLogout({ dispatch, commit }) {
			let $bus = new Vue().$bus;
			await dispatch("user/cleanToken");
			await commit("user/cleanUserInfo");
			await commit("story/cleanCreateStories");
			await commit("story/cleanEditStoryData");
			await commit("story/cleanStoryList");
			await commit("story/cleanPasswordStories");
			await commit("story/cleanStoryList");
			$bus.$emit("managerLogout");
		}
	}
});
